module.exports = __webpack_public_path__ + "img/_0.32f853cf.png";